export default "__VITE_ASSET__DhAyV4Qg__"